module.exports = __webpack_public_path__ + "img/type-6.156586b6.png";